/*
  Overlook hero bag links.
  Makes each coffee bag photo in the home page hero open that coffee's product page.
  It finds the product by matching the photo's file name to the product's own photos,
  so when the hero photos are swapped for new coffees the links follow automatically.
  A photo that doesn't match any product simply stays unlinked.
*/
(() => {
  const SELECTOR = '[class^="hero-first-image-template--"] img, [class^="hero-second-image-template--"] img';

  // "EliasPerez_bag_photo_1a2b3c4d-....png?v=1" -> "eliasperez_bag_photo"
  const key = (src) =>
    decodeURIComponent((src || '').split('?')[0].split('/').pop() || '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '')
      .replace(/_\d+x\d*$/i, '')
      .toLowerCase();

  const start = async () => {
    const imgs = [...document.querySelectorAll(SELECTOR)];
    if (!imgs.length) return;
    let products = [];
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(`${root}collections/all/products.json?limit=250`);
      products = (await res.json()).products || [];
    } catch (e) {
      return;
    }
    const byImage = new Map();
    products.forEach((p) => (p.images || []).forEach((i) => {
      const k = key(i.src);
      if (k && !byImage.has(k)) byImage.set(k, p);
    }));
    imgs.forEach((img) => {
      if (img.closest('a')) return;
      const p = byImage.get(key(img.currentSrc || img.src));
      if (!p) return;
      const a = document.createElement('a');
      a.href = `/products/${p.handle}`;
      a.className = 'hero-bag-link';
      a.setAttribute('aria-label', `Shop ${p.title}`);
      img.parentNode.insertBefore(a, img);
      a.appendChild(img);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
